<template>
    <Breadcrumbs main="Roles" title="List Roles" />
  
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>Roles List</h5>
              <router-link to="/roles/create" class="btn btn-primary float-end">Create Role</router-link>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="role in roles" :key="role.id">
                      <td>{{ role.attributes.name }}</td>
                      <td>{{ role.attributes.description }}</td>
                      <td>
                        <router-link :to="`/roles/edit/${role.id}`" class="btn btn-sm btn-light-primary me-2">Edit</router-link>
                        <button @click="deleteRole(role.id)" class="btn btn-sm btn-light-danger">Delete</button>
                      </td>
                    </tr>
                    <tr v-if="roles.length === 0">
                        <td colspan="3" class="text-center">No roles found</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import { get_roles, delete_role } from '@/services/roles';
  import Swal from 'sweetalert2';
  
  const roles = ref([]);
  
  const fetchRoles = async () => {
    const response = await get_roles();
    if (!response.error) {
      roles.value = response.data.data;
    }
  };
  
  const deleteRole = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    });
  
    if (result.isConfirmed) {
      const response = await delete_role(id);
      if (!response.error) {
        Swal.fire('Deleted!', 'Role has been deleted.', 'success');
        fetchRoles();
      } else {
        Swal.fire('Error!', 'Failed to delete role.', 'error');
      }
    }
  };
  
  onMounted(() => {
    fetchRoles();
  });
  </script>
